import React, { useCallback, useEffect, useState } from 'react';

import GaleryDesktopCarousel from '../../../components/Carousel/GaleryDesktopCarousel';
import GaleryMobileCarousel from '../../../components/Carousel/GaleryMobileCarousel/index';
import useMedia from '../../../hooks/useMedia';

import style from './galeria.module.scss';

export default function Galeria({ data }) {
  const isMobile = useMedia('(max-width: 768px)');

  const [tab, setTab] = useState(1);
  const [arrayItens, setArrayItens] = useState([]);

  const clearState = useCallback(() => setArrayItens([]), [setArrayItens]);

  const setTabItens = useCallback(
    (tabNumber: number) => {
      setTab(tabNumber);
      clearState();
      if (tabNumber === 1) {
        setArrayItens(data.galeria);
      } else if (tabNumber === 2) {
        setArrayItens(data.plantas);
      } else if (tabNumber === 3) {
        setArrayItens(data.obra);
      }
    },
    [data, clearState, setTab, setArrayItens],
  );

  useEffect(() => {
    setTabItens(1);
  }, [setTabItens]);

  if (!data) return null;

  const { galeria, plantas, obra } = data;

  return (
    <div className={style.gallery}>
      <div className={style.tabs}>
        {galeria ? (
          <h2
            role='presentation'
            onClick={() => setTabItens(1)}
            className={tab === 1 ? style.tabClicked : style.tabNotClicked}>
            Galeria
          </h2>
        ) : null}
        {plantas.length ? (
          <h2
            role='presentation'
            onClick={() => setTabItens(2)}
            className={tab === 2 ? style.tabClicked : style.tabNotClicked}>
            Planta Baixa
          </h2>
        ) : null}
        {obra.length ? (
          <h2
            role='presentation'
            onClick={() => setTabItens(3)}
            className={tab === 3 ? style.tabClicked : style.tabNotClicked}>
            Acompanhe a obra
          </h2>
        ) : null}
      </div>

      <div style={{ display: tab === 1 ? 'block' : 'none' }}>
        {isMobile ? (
          <GaleryMobileCarousel
            key={1}
            images={arrayItens}
            objectFit='cover'
          />
        ) : (
          <GaleryDesktopCarousel
            key={1}
            arrayItens={arrayItens}
          />
        )}
      </div>
      <div style={{ display: tab === 2 ? 'block' : 'none' }}>
        <GaleryMobileCarousel
          key={2}
          images={arrayItens}
          objectFit='cover'
        />
      </div>
      <div style={{ display: tab === 3 ? 'block' : 'none' }}>
        {isMobile ? (
          <GaleryMobileCarousel
            key={3}
            images={arrayItens}
            objectFit='cover'
          />
        ) : (
          <GaleryDesktopCarousel
            key={3}
            arrayItens={arrayItens}
          />
        )}
      </div>
    </div>
  );
}
